/* global $, API */

/**
 * Fetch the address from the API
 * @param  {String} postal Postal (e.g. 1234AB)
 * @param  {String} houseNumber House Number (e.g. 24)
 * @param  {String} country Country abbreviation (e.g. nl)
 * @return {Promise} jQuery promise from the ajax request
 */
export default function addressResolver(postal, houseNumber, country) {
  $.support.cors = true;

  return $.ajax({
    url: API.address,
    data: {
      postal_code: postal,
      house_number: houseNumber,
      country_code: country,
    },
    type: 'POST',
    dataType: 'json',
    error: (err) => {
      console.log(err); // eslint-disable-line
    },
  });
}
